// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"2f269cba","172":"9ca92cc1","210":"11848451","640":"8eb65b1a"}[chunkId] + ".chunk.js";
};